import { Table } from "antd";
import "antd/dist/antd.css";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import useSWR from "swr";
import useAuth from "../../../../initialpage/hooks/useAuth";
import { itemRender, onShowSizeChange } from "../../../paginationfunction";
import NotFoundPage from "../../StoreComponents/NotFoundPage";
import { API } from "../../StoreComponents/conflict";
import { PostStoreLog } from "../../StoreComponents/hooks/useStoreLog";
import Cookies from "js-cookie";
const fetcher = (url) => API.get(url).then((res) => res.data.data);

const RequestProUser = () => {
  const user = JSON.parse(Cookies.get("user") || '{}');
  const empID = parseInt(Cookies.get("E_Id"));
  const [singleData, setSingleData] = useState();
  const [denyRecord, setDenyRecord] = useState();
  const [arrayData, setArrayData] = useState([]);
  const [openElement, setOpenElement] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  // console.log(stockProduct)
  const handleToggle = () => {
    if (!openElement) {
      setOpenElement(true);
    } else {
      setOpenElement(false);
    }
  };

  const {
    data: dataSource,
    error,
    mutate,
  } = useSWR(`store/requisition/product/request/user`, fetcher);
  console.log(dataSource);
  // console.log(singleData);

  const columns = [
    {
      title: "Request ID",
      className: "dark_bg ",
      dataIndex: "REQUEST_ID",
    },
    {
      title: "Date",
      className: "dark_bg ",
      render: (text, record) => <td>{record.REQUEST_DATE.split("T")[0]}</td>,
    },

    {
      title: "Request Qty",
      className: "dark_bg text-center",
      dataIndex: "TOTAL_REQUEST_QTY",
    },
    {
      title: "Approve Qty",
      className: "dark_bg text-center",
      dataIndex: "TOTAL_APPROVED_QTY",
    },
    {
      title: "Status",
      className: "dark_bg text-center",
      render: (text, record) => (
        <td className=" pt-2 ">
          <span className="bg-success text-white px-3 py-1 rounded-3">
            {record.REQUEST_STATUS === 1
              ? "Approved"
              : record.REQUEST_STATUS === 2
                ? "Checked"
                : record.REQUEST_STATUS === 3
                  ? "Not Approved"
                  : "Pending"}
          </span>
        </td>
      ),
    },

    {
      title: "Action",
      className: "dark_bg text-center ",
      render: (text, record) => (
        <>
          <td className="">
            <Link to={`/requisition/requestProduct/slip/${record.REQUEST_ID}`}>
              <button
                className="fs-6"
                style={{
                  backgroundColor: "#3C8DBC",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i className="fa fa-eye m-r-5" /> View
              </button>
            </Link>
            {record.REQUEST_STATUS === 3 && (
              <button
                className="fs-6 ms-1 bg-success"
                data-toggle="modal"
                data-target="#reasonModal"
                onClick={() => {
                  setDenyRecord(record.DENY_REMARK);
                }}
                style={{
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i class="fa fa-circle-info m-r-5"></i> Reason
              </button>
            )}
          </td>
        </>
      ),
    },
  ];

  // console.log(error);
  // react hook form
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = (data) => {
    const product = {
      REQUEST_QTY: parseFloat(data.REQUEST_QTY),
      PRODUCT_NAME: data.PRODUCT_NAME,
      REQUEST_REMARKS: data.REQUEST_REMARKS,
      UNIT: data.UNIT,
    };
    //   console.log(product);
    setArrayData([...arrayData, product]);
    reset();
  };
  const deleteProduct = (id) => {
    console.log(id);
    const proceed = window.confirm("Are you sure?");
    if (proceed) {
      const remaining = arrayData.filter((product, index) => index !== id);
      setArrayData(remaining);
    }
  };
  const handleRequest = () => {
    swal({
      title: "Are you sure?",
      //  text: "Once deleted, you will not be able to recover this imaginary file!",
      buttons: true,
      //  dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setButtonLoading(true);
        if (arrayData.length > 0) {
          API.post("store/requisition/product/request/user", {
            user_id: parseInt(empID),
            products: arrayData,
          }).then((res) => {
            console.log(res);
            if (!res.data.error) {
              swal({
                title: "Thank You !",
                text: "Successfully Added",
                icon: "success",
                button: "Ok",
              });
              PostStoreLog(1, "new request");
              setButtonLoading(false);
              setArrayData([]);
              setOpenElement(false);
              mutate();
            }
          });
        } else {
          alert("Sorry, You dont have any data!");
        }
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  console.log(arrayData);

  return (
    <>
      <Helmet>
        <title>Request Product - BBA STORE</title>
        <meta name="description" content="Request Product - BBA STORE" />
      </Helmet>

      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important} "
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4 search-div_store">
            <h3 className="text-start text-dark">Manage Request Product</h3>
            <button
              onClick={handleToggle}
              type="button"
              className="btn  px-3 btn-color_store"
            >
              <i className="fa fa-plus"></i>
              <span> Add Request Product</span>
            </button>
          </div>

          {/* Toogle Element */}
          <div
            className={openElement ? "category_store show" : "category_store"}
          >
            <div className="mx-auto text-center">
              <div className="add_category">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="container px-4">
                    <div className="row gx-5">
                      <div className="col-sm-6">
                        {" "}
                        <div className="col-sm-12">
                          <label htmlFor="Quantity">
                            Product Name <span className="color-red">*</span>
                          </label>
                          <div className="pass-wrapper d-flex input-group mb-3">
                            <input
                              {...register("PRODUCT_NAME")}
                              type="text"
                              placeholder="Enter Product Name"
                              className=" form-control "
                              required
                            />
                          </div>
                        </div>
                        <div className="row container">
                          <div className="col-sm-12 col-md-6 col-lg-6">
                            <label htmlFor="Quantity">
                              Quantity <span className="color-red">*</span>
                            </label>
                            <div className="pass-wrapper d-flex input-group mb-3">
                              <input
                                {...register("REQUEST_QTY")}
                                type="number"
                                min="1"
                                step={0.01}
                                placeholder="Enter Quantity"
                                className=" form-control "
                                required
                              />
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-6 col-lg-6">
                            <label htmlFor="Unit">
                              Unit <span className="color-red">*</span>
                            </label>
                            <div className="pass-wrapper d-flex input-group mb-3">
                              <input
                                {...register("UNIT")}
                                type="text"
                                placeholder="Enter Unit Name"
                                className=" form-control "
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-12">
                          <label htmlFor="remarks">Remarks</label>
                          <textarea
                            {...register("REQUEST_REMARKS")}
                            placeholder="Enter Remarks"
                            className="input-field-new p-2"
                            cols="30"
                            rows="3"
                          ></textarea>
                        </div>
                        <button
                          type="submit"
                          className="mt-3 px-3 btn btn-color_store"
                        >
                          <i className="fa fa-add"></i>
                          <span> Add</span>
                        </button>
                      </div>
                      <div className="col-sm-6">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className="tableColor">
                              <th>S/N</th>
                              <th>Product Name</th>
                              <th>Quantity</th>
                              <th>Unit</th>
                              <th>Remarks</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {arrayData?.map((item, index) => (
                              <tr>
                                <td>{++index}</td>
                                <td className="text-start">
                                  {item.PRODUCT_NAME}
                                </td>
                                <td>{item.REQUEST_QTY}</td>
                                <td>{item.UNIT}</td>
                                <td className="text-start">
                                  {item.REQUEST_REMARKS}
                                </td>
                                <td>
                                  {" "}
                                  <button
                                    onClick={() => deleteProduct(--index)}
                                    data-bs-toggle="tooltip"
                                    title="Delete"
                                    type="button"
                                    className="btn btn-red_store px-3"
                                  >
                                    <i className="fa fa-times fs-6"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <br />
                  {!buttonLoading ? (
                    <button
                      onClick={handleRequest}
                      className="btn btn-color_store px-3 mt-3"
                    >
                      {" "}
                      <i className="fa fa-send-o" /> <span>Send Request</span>
                    </button>
                  ) : (
                    <button className="btn btn-color_store px-3 mt-3">
                      {" "}
                      <i className="fa fa-send-o" /> <span>Send Request</span>
                      <div
                        style={{ width: "20px", height: "20px" }}
                        class="spinner-border ms-2  text-light"
                        role="status"
                      >
                        <span style={{}} class="visually-hidden ">
                          Loading...
                        </span>
                      </div>
                    </button>
                  )}
                </form>
              </div>
            </div>
          </div>
          {/* Toogle Element */}

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            {!dataSource ? (
              <NotFoundPage />
            ) : (
              <div className="row ">
                <div className="col-md-12 ">
                  <div className="table-responsive">
                    <Table
                      className="table-striped"
                      pagination={{
                        total: dataSource === undefined ? 0 : dataSource.length,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        showSizeChanger: true,
                        onShowSizeChange: onShowSizeChange,
                        itemRender: itemRender,
                      }}
                      style={{ overflowX: "auto" }}
                      columns={columns}
                      // bordered
                      dataSource={dataSource === undefined ? [] : dataSource}
                      rowKey={(record) => record.RWID}
                      onChange={console.log("change")}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div id="reasonModal" className="modal custom-modal fade" role="dialog">
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">View Reason </h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              >
              </button>
            </div>
            <div className="modal-body text-start">
              <h4 className="text-danger">{denyRecord}</h4>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestProUser;
